import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=b5a66cac"
import script from "./main-header.vue?vue&type=script&lang=ts"
export * from "./main-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports